<template>
  <div class="mt-1 mx-1">
    <div>
      <div class="mb-1">
        <h4>{{ $t('order.filters.title') }}</h4>
      </div>

      <div class="w-full">
        <div class=" mb-1">
          <label class="vs-input--label block">
            {{ $t('order.filters.label.type') }}
          </label>
          <v-select
            v-model="filters.types"
            multiple
            clearable
            :options="orderTypes"
            :close-on-select="false"
          >

            <template #selected-option="option">
              <span>
                {{ $t('order.types.' + option.label ) }}
              </span>
            </template>

            <template #option="option">
              {{ $t('order.types.' + option.label) }}
            </template>

          </v-select>
        </div>

        <div class=" mb-1">
          <label class="vs-input--label block">
            {{ $t('order.filters.label.status') }}
          </label>
          <v-select
            v-model="filters.statuses"
            multiple
            clearable
            :options="statuses"
            :close-on-select="false"
          >

            <template #selected-option="option">
              <span>
                {{ $t('order.status.' + option.label ) }}
              </span>
            </template>

            <template #option="option">
              {{ $t('order.status.' + option.label) }}
            </template>

          </v-select>
        </div>

        <div class="mb-1">

          <label class="vs-input--label block">
            {{ $t('order.filters.label.start-date-from') }}
          </label>

          <flat-pickr
            v-model="filters.startAtFrom"
            class="form-control"
            :config="configDateTimePicker"
          />

        </div>

        <div class="mb-2">

          <label class="vs-input--label block">
            {{ $t('order.filters.label.start-date-to') }}
          </label>

          <flat-pickr
            v-model="filters.startAtTo"
            class="form-control"
            :config="configDateTimePicker"
          />
        </div>
      </div>
    </div>

    <div>
      <b-button
        v-b-toggle.filters-sidebar
        variant="primary"
        block
      >
        {{ $t('shared.button.close') }}
      </b-button>
    </div>

    <div
      v-show="flatFilters.length"
    >

      <h4 class="mt-3 mb-1">
        {{ $t('order.filters.active') }}:
      </h4>
      <b-badge
        v-for="(elem, key) in flatFilters"
        :key="key"
        class="font-medium-1 mb-50 cursor-pointer"
        variant="light-primary"
        @click="removeFilter(elem.path)"
      >
        <feather-icon
          icon="XIcon"
          class="font-medium-2 mr-50"
        />
        <i class="font-medium-1">{{ elem.label }}</i>: {{ elem.value }}
      </b-badge>

      <div class="clear-both" />
    </div>

  </div>
</template>
<script>
import { Polish as PolishLocale } from 'flatpickr/dist/l10n/pl'
import { empty } from '@/helpers/helpers'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.min.css'
import vSelect from 'vue-select'
import { BBadge, BButton, VBToggle } from 'bootstrap-vue'

export default {
  name: 'OrderFilters',
  components: {
    flatPickr,
    vSelect,

    BButton,
    BBadge,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: {
    showFilter: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      originalFilters: {},
      configDateTimePicker: {
        locale: PolishLocale,
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        defaultHour: 6,
        disableMobile: true,
      },
    }
  },
  computed: {
    statuses() {
      return this.$store.getters['order/getStatuses']
    },
    orderTypes() {
      const types = this.$store.getters['order/getTypes']
      return types ? Object.values(types) : []
    },
    flatFilters() {
      const flat = []

      if (this.filters.startAtFrom) {
        flat.push({
          path: ['startAtFrom'],
          label: this.$t('order.filters.label.start-date-from'),
          value: this.filters.startAtFrom,
        })
      }

      if (this.filters.startAtTo) {
        flat.push({
          path: ['startAtTo'],
          label: this.$t('order.filters.label.start-date-to'),
          value: this.filters.startAtTo,
        })
      }

      if (!empty(this.filters.statuses)) {
        this.filters.statuses.forEach((status, key) => {
          flat.push({
            path: ['statuses', key],
            label: this.$t('order.filters.label.status'),
            value: this.$t(`order.status.${status}`),
          })
        })
      }

      if (!empty(this.filters.types)) {
        this.filters.types.forEach((type, key) => {
          flat.push({
            path: ['types', key],
            label: this.$t('order.filters.label.type'),
            value: this.$t(`order.types.${type}`),
          })
        })
      }

      return flat
    },
  },
  methods: {
    empty,
    removeFilter(path) {
      const { filters } = this

      if (path.length === 1) {
        filters[path[0]] = ''
      }
      if (path.length === 2) {
        const newArray = []
        filters[path[0]].forEach((filter, key) => {
          if (key !== path[1]) {
            newArray.push(filter)
          }
        })
        filters[path[0]] = newArray
      }

      this.filters = filters
    },
  },
}
</script>
